(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5001],{

/***/ 2438:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/landing-pages-v2/[...slug]",
      function () {
        return __webpack_require__(4191);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 35316:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ StickyCTABarContextProvider; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99758);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78049);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44194);



var StickyCTABarContext = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createContext({
    visible: false,
    setVisible: function() {
        return null;
    }
});
var StickyCTABarContextProvider = function(param) {
    var children = param.children;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_0__.useState(false), 2), visible = ref[0], setVisible = ref[1];
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(StickyCTABarContext.Provider, {
        value: {
            visible: visible,
            setVisible: setVisible
        },
        children: children
    });
};


/***/ }),

/***/ 4191:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(36690);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(93089);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@emotion+react@11.11.1_@types+react@18.3.28_react@18.3.1/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(78049);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.3.1/node_modules/react/index.js
var react = __webpack_require__(44194);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/ContactSection.tsx
var ContactSection = __webpack_require__(18465);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/FCContactUs.tsx
var FCContactUs = __webpack_require__(65532);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/FCHero.tsx
var FCHero = __webpack_require__(20009);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/FCMap.tsx
var FCMap = __webpack_require__(96567);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/FCMissionStatement.tsx
var FCMissionStatement = __webpack_require__(96261);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/FCProductOptions.tsx
var FCProductOptions = __webpack_require__(40925);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/FCTestimonialCarousel.tsx
var FCTestimonialCarousel = __webpack_require__(76693);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/FCThreeSteps.tsx
var FCThreeSteps = __webpack_require__(40872);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/FCTrustBanner.tsx
var FCTrustBanner = __webpack_require__(31095);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/FCValueTracker.tsx
var FCValueTracker = __webpack_require__(15005);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/HeroV2.tsx + 3 modules
var HeroV2 = __webpack_require__(96911);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/HeroV2WithMarkers.tsx + 2 modules
var HeroV2WithMarkers = __webpack_require__(49940);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/LWCHeroCard.tsx
var LWCHeroCard = __webpack_require__(89971);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/LWCImageCard.tsx
var LWCImageCard = __webpack_require__(70848);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/LWCTextSection.tsx
var LWCTextSection = __webpack_require__(81659);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/MapBackgroundHero.tsx
var MapBackgroundHero = __webpack_require__(90323);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/PhotoTestimonials.tsx
var PhotoTestimonials = __webpack_require__(93315);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/Spacer.tsx
var Spacer = __webpack_require__(38898);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/StandaloneText.tsx
var StandaloneText = __webpack_require__(44736);
// EXTERNAL MODULE: ./src/cms/entries/dynamicEntry.ts
var dynamicEntry = __webpack_require__(39745);
;// CONCATENATED MODULE: ./src/cms/entries/homePageV2.ts




















// CarouselCards swaps mobile/desktop subtrees via useMedia, so it stays client-only.
var CarouselCards = (0,dynamicEntry/* dynamicEntry */.f)(function() {
    return __webpack_require__.e(/* import() */ 8554).then(__webpack_require__.bind(__webpack_require__, 98554));
});
// Browser-only iframe runtime stays client-only.
var SuperIframe = (0,dynamicEntry/* dynamicEntry */.f)(function() {
    return __webpack_require__.e(/* import() */ 2981).then(__webpack_require__.bind(__webpack_require__, 12981));
});
var TextBanner = (0,dynamicEntry/* dynamicEntry */.f)(function() {
    return __webpack_require__.e(/* import() */ 9574).then(__webpack_require__.bind(__webpack_require__, 69574));
});
var homePageV2EntryLookup = {
    // only including blocks used in https://app.contentful.com/spaces/bjlp9d7o6h1o/entries/3jH3XGe228kfdp8fBGddyW?focusedField=slug
    // for performance
    block: {
        lpComponentMapBackgroundHero: MapBackgroundHero/* default */.Z,
        lpComponentCarouselCards: CarouselCards,
        lpComponentContactSection: ContactSection/* default */.Z,
        lpComponentLwcTextSection: LWCTextSection/* default */.Z,
        lpComponentLwcHeroCard: LWCHeroCard/* default */.Z,
        lpComponentLwcImageCard: LWCImageCard/* default */.Z,
        lpComponentHeroV2: HeroV2/* default */.ZP,
        lpComponentHeroV2WithMarkers: HeroV2WithMarkers/* default */.Z,
        lpComponentSpacer: Spacer/* default */.Z,
        lpComponentStandaloneText: StandaloneText/* default */.Z,
        fcHero: FCHero/* default */.Z,
        fcTrustBanner: FCTrustBanner/* default */.Z,
        fcValueTracker: FCValueTracker/* default */.Z,
        fcThreeSteps: FCThreeSteps/* default */.Z,
        fcProductOptions: FCProductOptions/* default */.Z,
        fcTestimonialCarousel: FCTestimonialCarousel/* default */.Z,
        fcMap: FCMap/* default */.Z,
        fcMissionStatement: FCMissionStatement/* default */.Z,
        fcContactUs: FCContactUs/* default */.Z,
        lpComponentTextBanner: TextBanner,
        lpComponentPhotoTestimonials: PhotoTestimonials/* default */.Z,
        componentSuperIframe: SuperIframe
    },
    inline: {}
};
/* harmony default export */ var homePageV2 = (homePageV2EntryLookup);

// EXTERNAL MODULE: ./src/cms/entries/landingPageV2.ts + 24 modules
var landingPageV2 = __webpack_require__(71747);
// EXTERNAL MODULE: ./src/cms/renderer/index.tsx
var renderer = __webpack_require__(64255);
// EXTERNAL MODULE: ./src/helpers/observability.ts
var observability = __webpack_require__(6324);
// EXTERNAL MODULE: ./src/helpers/ReturnExperienceContext.tsx
var ReturnExperienceContext = __webpack_require__(55876);
// EXTERNAL MODULE: ./src/helpers/StickyCTABarContext.tsx
var StickyCTABarContext = __webpack_require__(35316);
// EXTERNAL MODULE: ../../node_modules/.pnpm/next@12.3.4_@babel+core@7.29.0_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.99.0/node_modules/next/router.js
var next_router = __webpack_require__(62281);
// EXTERNAL MODULE: ./src/pages/shared/LandingPageV2Layout.tsx + 2 modules
var LandingPageV2Layout = __webpack_require__(71342);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-scroll-parallax@3.5.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/react-scroll-parallax/dist/index.mjs + 1 modules
var dist = __webpack_require__(99293);
;// CONCATENATED MODULE: ./src/pages/landing-pages-v2/[...slug].tsx













var LandingPageWithContext = function(props) {
    var trackJourneyEvent = (0,observability/* useObservability */.C3)().trackJourneyEvent;
    var router = (0,next_router.useRouter)();
    var nextJsPath = router.asPath.split("?")[0];
    var isHomePage = nextJsPath === "/"; // || true to debug HP perf
    var cmsEntryLookup = isHomePage ? homePageV2 : landingPageV2/* default */.Z;
    (0,react.useEffect)(function() {
        // only measuring homepage load-time performance
        if (false) {}
        // only measuring if the slug contains 'homepage'
        // we have a few variants of the homepage like /homepage-syw-v2-home-guide
        if (window.location.pathname !== "/") return;
        trackJourneyEvent("platform", "pageLoadedEvent", {
            // Next.js route, which is not necessarily the client-side URL
            routerPath: nextJsPath,
            loadTimeMs: Math.round(performance.now())
        });
    }, []);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* ParallaxProvider */.Xu, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ReturnExperienceContext/* ReturnExperienceContextProvider */.Q, {
            showReturnExperience: props.fields.showReturnExperienceBanner,
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StickyCTABarContext/* StickyCTABarContextProvider */.H, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LandingPageV2Layout["default"], (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(renderer/* default.Component */.Z.Component, {
                        body: props.fields.body,
                        idToLoaderData: props.idToLoaderData,
                        entryLookup: cmsEntryLookup
                    })
                }))
            })
        })
    });
};
var __N_SSP = true;
/* harmony default export */ var _slug_ = (LandingPageWithContext);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3985,6183,9115,6805,899,9927,3532,2817,4021,1267,9988,6184,1586,9293,7434,6636,4573,1515,323,3165,5925,3970,1342,9774,2888,179], function() { return __webpack_exec__(2438); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);